(ns net.kestec.mhda-pilgrimage.public.application.form.application-form-step3
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Button" :default Button]
    ["@mui/material/Select" :default Select]
    ["@mui/material/MenuItem" :default MenuItem]
    ["@mui/material/Grid" :default Grid]
    ["@mui/material/Chip" :default Chip]
    ["@mui/material/Table" :default Table]
    ["@mui/material/TableBody" :default TableBody]
    ["@mui/material/TableRow" :default TableRow]
    ["@mui/material/TableCell" :default TableCell]
    ["@mui/material/FormHelperText" :default FormHelperText]



    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-medium grid-full text-field text-field-multi checkbox select radio-yes-no radio-group checkbox-group]]
    [net.kestec.mhda-pilgrimage.lib-ui.form-uploads :as form-uploads]
    [net.kestec.mhda-pilgrimage.lib-ui.form-validator :refer [form-field-validator form-validator check-min-text-length check-not-nil check-integer check-count check-combine-or]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as-alias application-events]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-substep-documents :as substep-documents]
    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]
    ))



(def VALIDATOR
  (merge {
          :mhda_member         {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "Malteser?"}
          :mhda_certified      {:check-fn (check-combine-or (fn [data] (false? (:mhda_member data))) (check-not-nil)) :error-text "Bitte eine Antwort wählen" :missing-text "Pflegefortbildung"}
          :mhda_service_no     {:check-fn (check-combine-or (fn [data] (false? (:mhda_member data))) (check-min-text-length 2)) :error-text "Min 2 Stellen" :missing-text "Dienstnummer"}
          :mhda_type           {:check-fn (check-combine-or (fn [data] (false? (:mhda_member data))) (check-not-nil)) :error-text "Bitte eine Antwort wählen" :missing-text "Fahre mit als?"}

          :q_help_mobility_2km {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "2km gehen"}
          :mobility            {:check-fn (check-combine-or (fn [data] (false? (:q_help_mobility_2km data))) (check-integer 1 10)) :error-text "Bitte Hilfsmittel angeben" :missing-text "Mobilität"}

          :q_help_bed          {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "2km gehen"}
          :q_help_clothing     {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "Anziehen"}
          :q_help_hygiene      {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "Hygiene"}
          :q_help_feeding      {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "Essen"}
          :q_help_toilette     {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "Toilette"}
          :q_chronic_illness   {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "chronische Krankheit"}
          :q_help_medical      {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "ärztliche Betreuung"}


          :diet_diabetes       {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "Diät Diabetes"}
          :diet_zoeliakie      {:check-fn (check-not-nil) :error-text "Bitte eine Antwort wählen" :missing-text "Diät Zoeliakie"}
          :diet_text           {}

          }
         substep-documents/VALIDATOR
         ))

(defn main []
  (let [!application (rf/subscribe [::db/get ::db/selected-application])
        field-validator (form-field-validator VALIDATOR !application)
        form-valid (form-validator VALIDATOR !application)]
    [:> Grid {:container true}
     [grid-full [:> Typography {:variant "h3"} "3. Reisedetails"]]
     [grid-full [:> Typography {:variant "h4"} "Ich bin MHDA-Mitglied"]]
     [grid-small
      "Ich bin MHDA-Mitglied"]
     [grid-small
      [radio-yes-no
       {:label      ""
        :value      (:mhda_member @!application)
        :error      (:error (field-validator :mhda_member))
        :helperText (:helperText (field-validator :mhda_member))
        :onChange   #(rf/dispatch [::application-events/store-value :mhda_member %])
        }]
      ]
     [grid-full]
     (when (:mhda_member @!application)
       [:<>
        [grid-small
         "Ich habe eine gültige Pflegerezertifizierung"]
        [grid-small
         [radio-yes-no
          {:label      ""
           :value      (:mhda_certified @!application)
           :error      (:error (field-validator :mhda_certified))
           :helperText (:helperText (field-validator :mhda_certified))
           :onChange   #(rf/dispatch [::application-events/store-value :mhda_certified %])
           }]]
        [grid-full]
        [grid-small
         [text-field {:label      "Meine Dienstnummer"
                      :value      (:mhda_service_no @!application)
                      :onChange   #(rf/dispatch [::application-events/store-value :mhda_service_no %])
                      :error      (:error (field-validator :mhda_service_no))
                      :helperText (:helperText (field-validator :mhda_service_no))
                      }]]

        [grid-full]
        [grid-medium
         [select {:value      (or (:mhda_type @!application) "PI")
                  :fullWidth  true
                  :label      "Ich fahre mit als"
                  :error      (:error (field-validator :mhda_type))
                  :helperText (:helperText (field-validator :mhda_type))
                  :onChange   #(rf/dispatch [::application-events/store-value :mhda_type %])}
          [:> MenuItem {:value "PI"} "Pilger"]
          [:> MenuItem {:value "PE"} "Personal"]
          [:> MenuItem {:value "HPI"} "Pilger und möchte Helfen"]
          ]]
        ])


     [grid-full [:> Typography {:variant "h4"} "Medizinischer Kurzfragebogen"]]




     [grid-full [:> Typography {:variant "p" :sx {:fontWeight "bold"}}
                 "Dieser Kurzfragebogen dient zur Information und zur Vorbereitung unserer Ärzte und Krankenschwestern, "
                 "um auf der Reise die bestmögliche ärztliche und pflegerische Unterstützung und Betreuung "
                 "gewährleisten zu können. Wir bitten Sie daher, diesen Fragebogen genau, ehrlich und vollständig zu "
                 "beantworten. Alle Informationen werden selbstverständlich vertraulich behandelt."]]


     [grid-full [:> Typography {:variant "p" :sx {:fontWeight "bold"}}
                 "Der medizinische Fragebogen erscheint bei ALLEN, weil gesundheitliche Informationen nicht nur bei Kranken/Behinderten relevant sind. "
                 "z.B.: Auch unsere eigenen Mitglieder können Allergien haben oder medizinische Besonderheiten mitbringen. " [:br]
                 "Für das medizinische Team ist es wichtig, diese Informationen im Ernstfall sofort verfügbar zu haben, um schnell und richtig reagieren zu können."]]




     [grid-full [:> Typography {:variant "p" :sx {}}
                 "Beantworten Sie bitte die folgenden Fragen mit JA "
                 [:ul
                  [:li "auch, wenn Ihnen diese Hilfe auf der Reise von einem Angehörigen geleistet wird "]
                  [:li "oder auch im Zweifelsfall "]

                  ]]]


     [:> Table
      [:> TableBody


       [:> TableRow
        [:> TableCell
         [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfsmittel/Hilfe wenn ich länger gehe (> 2km)"]]
        [:> TableCell
         [radio-yes-no
          {:value      (:q_help_mobility_2km @!application)
           :error      (:error (field-validator :q_help_mobility_2km))
           :helperText (:helperText (field-validator :q_help_mobility_2km))
           :onChange   #(rf/dispatch [::application-events/store-value :q_help_mobility_2km %])
           }]]]

       (when (:q_help_mobility_2km @!application)
         [:> TableRow
          [:> TableCell
           [:span "Ich " [:span {:style {:textDecoration "underline"}} "nutze"] " folgendes Hilfsmittel"]]
          [:> TableCell
           [select {:value      (or (:mobility @!application) "0")
                    :fullWidth  true
                    :error      (:error (field-validator :mobility))
                    :helperText (:helperText (field-validator :mobility))
                    :onChange   #(rf/dispatch [::application-events/store-value :mobility %])}
            ;[:> MenuItem {:value "0"} "kein Hilfsmittel"]
            [:> MenuItem {:value "2"} "gelegentlich Stock"]
            [:> MenuItem {:value "3"} "ich gehe mit Stock"]
            [:> MenuItem {:value "4"} "ich nutze einen Rollator"]
            [:> MenuItem {:value "5"} "ich nutze einen Rollstuhl"]
            [:> MenuItem {:value "6"} "ich nutze einen elektrischen Rollstuhl"]
            [:> MenuItem {:value "7"} "Rollstuhl nicht umsetzbar"]

            ]
           ]])




       [:> TableRow
        [:> TableCell
         [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe beim Aufstehen oder Zubettgehen"]]
        [:> TableCell
         [radio-yes-no
          {:value      (:q_help_bed @!application)
           :error      (:error (field-validator :q_help_bed))
           :helperText (:helperText (field-validator :q_help_bed))
           :onChange   #(rf/dispatch [::application-events/store-value :q_help_bed %])
           }]]]

       [:> TableRow
        [:> TableCell
         [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe beim An- und Auskleiden"]]
        [:> TableCell
         [radio-yes-no
          {:value      (:q_help_clothing @!application)
           :error      (:error (field-validator :q_help_clothing))
           :helperText (:helperText (field-validator :q_help_clothing))
           :onChange   #(rf/dispatch [::application-events/store-value :q_help_clothing %])
           }]]]

       [:> TableRow
        [:> TableCell
         [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe bei der Körperpflege"]]
        [:> TableCell
         [radio-yes-no
          {:value      (:q_help_hygiene @!application)
           :error      (:error (field-validator :q_help_hygiene))
           :helperText (:helperText (field-validator :q_help_hygiene))
           :onChange   #(rf/dispatch [::application-events/store-value :q_help_hygiene %])
           }]]]

       [:> TableRow
        [:> TableCell
         [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe beim Essen und Trinken"]]
        [:> TableCell
         [radio-yes-no
          {:value      (:q_help_feeding @!application)
           :error      (:error (field-validator :q_help_feeding))
           :helperText (:helperText (field-validator :q_help_feeding))
           :onChange   #(rf/dispatch [::application-events/store-value :q_help_feeding %])
           }]]]

       [:> TableRow
        [:> TableCell
         [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " Hilfe auf der Toilette"]]
        [:> TableCell
         [radio-yes-no
          {:value      (:q_help_toilette @!application)
           :error      (:error (field-validator :q_help_toilette))
           :helperText (:helperText (field-validator :q_help_toilette))
           :onChange   #(rf/dispatch [::application-events/store-value :q_help_toilette %])
           }]]]

       [:> TableRow
        [:> TableCell
         [:span "Ich " [:span {:style {:textDecoration "underline"}} "leide"] " an einer schweren chronischen Krankheit"]]
        [:> TableCell
         [radio-yes-no
          {:value      (:q_chronic_illness @!application)
           :error      (:error (field-validator :q_chronic_illness))
           :helperText (:helperText (field-validator :q_chronic_illness))
           :onChange   #(rf/dispatch [::application-events/store-value :q_chronic_illness %])
           }]]]

       [:> TableRow
        [:> TableCell
         [:span "Ich " [:span {:style {:textDecoration "underline"}} "brauche"] " ärztliche oder pflegerische Betreuung"]]
        [:> TableCell
         [radio-yes-no
          {:value      (:q_help_medical @!application)
           :error      (:error (field-validator :q_help_medical))
           :helperText (:helperText (field-validator :q_help_medical))
           :onChange   #(rf/dispatch [::application-events/store-value :q_help_medical %])
           }]]]
       ]]

     [substep-documents/main]

     [grid-full [:> Typography {:variant "h1"} " "]]
     [grid-full [:> Typography {:variant "h1"} " "]]
     [grid-full [:hr]]

     [grid-full [:> Typography {:variant "h5"} "Ernährung und Diäten"]]
     [grid-full [:> Typography {:variant "p"} "Besteht bei Ihnen eine medizinisch bedingte Diät oder spezielle Ernährungsform (z.B. Diabetes, glutenfrei, laktosefrei, Nierenkost etc.)?"]]
     [grid-full
      [radio-yes-no
       {:label      "Diabetes"
        :value      (:diet_diabetes @!application)
        :error      (:error (field-validator :diet_diabetes))
        :helperText (:helperText (field-validator :diet_diabetes))
        :onChange   #(rf/dispatch [::application-events/store-value :diet_diabetes %])
        }]]

     [grid-full
      [radio-yes-no
       {:label      "Zöliakie"
        :value      (:diet_zoeliakie @!application)
        :error      (:error (field-validator :diet_zoeliakie))
        :helperText (:helperText (field-validator :diet_zoeliakie))
        :onChange   #(rf/dispatch [::application-events/store-value :diet_zoeliakie %])
        }]]
     [grid-full

      [:br]
      [text-field-multi
       {:label      "Bitte wenn möglich, um Berücksichtigung folgender sonstiger Allergien und Diäten"
        :value      (or (:diet_text @!application) "")
        :onChange   #(rf/dispatch [::application-events/store-value :diet_text %])
        :error      (:error (field-validator :diet_text))
        :helperText (:helperText (field-validator :diet_text))
        }]]

     [grid-full
      ;[:pre (pr-str form-valid)]
      (when-not (:valid form-valid)
        (into [:<> "Es fehlen noch folgende Eingaben: "]
              (for [missing (:formMissingText form-valid)]
                [:> Chip {:label (str missing) :sx {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
              ))
      ]

     ]

    ))